export {default as PaymentHistoryPage} from './PaymentHistoryPage';



// WEBPACK FOOTER //
// ./src/pages/PaymentHistoryPage/index.ts